import { XmlSchemaIdentityConstraint } from './XmlSchemaIdentityConstraint';

export class XmlSchemaKey extends XmlSchemaIdentityConstraint {}
